const domains = {
	"prod.fe.nimm2-der-sommer-lacht-fe.campaign-loyalty.com": {
		apibase: "/",
	},
}
export const getEnvConfig = () => {
	return domains[window.location.host] || { apibase: "/inte/" }
}
